import { authedApiFetch } from 'utils/Api';

const healthScoresService = {
	// GET /health_scores returns an array ordered most-recent first, so callers
	// can take [0] for the latest score. Both params are optional server-side.
	getHealthScores: async ({
		salesforceObjectId,
		salesforceObjectType = 'Account',
	} = {}) => {
		const params = new URLSearchParams();
		if (salesforceObjectId)
			params.set('salesforce_object_id', salesforceObjectId);
		if (salesforceObjectType)
			params.set('salesforce_object_type', salesforceObjectType);

		const queryString = params.toString();
		const endpoint = `/health_scores${queryString ? `?${queryString}` : ''}`;

		return await authedApiFetch({
			endpoint,
			method: 'GET',
		});
	},
};

export default healthScoresService;
